<div class="sem-switch">
    <p>IN</p><img (click)="click()" [src]="img" /><p>ALI</p>
</div>